import React from 'react'

const RelationshipProof = () => {
    return (
        <div>RelationshipProof</div>
    )
}

export default RelationshipProof